import React, { Component } from "react";
import "../../style/common/footerBar.scss";
import Facebook from "../../icon/Facebook";
import Instagram from "../../icon/Instagram";
import Pinterest from "../../icon/Pinterest";
import logo from "../../image/logo-email.png";
import TikTok from "../../icon/TikTok";
import { routePage } from "../../utils/routePage";
import footer_leaf from "../../image/footer-leaf.avif";
import Twtter from "../../icon/Twtter";
import f1 from "../../image/f1.png";
import f2 from "../../image/f2.png";
import f3 from "../../image/f3.png";
import f4 from "../../image/f4.png";
import f5 from "../../image/f5.png";

class FooterBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { history } = this.props;
    return (
      <React.Fragment>
        <div className="footerBar">
          <div className="row">
            <div className="col">
              <h6>Buying on Folksy</h6>
              <p onClick={() => routePage(history, "/ship")}>Delivery</p>
              <p onClick={() => routePage(history, "/return")}>Returns</p>
              <div className="iocn-row">
                <a
                  className="icon"
                  href="https://www.pinterest.com"
                  target="_blank"
                >
                  <img src={f1} alt="" />
                </a>
                <a
                  className="icon"
                  href="https://www.facebook.com"
                  target="_blank"
                >
                  <img src={f2} alt="" />
                </a>
                <a
                  className="icon"
                  href="https://www.twitter.com"
                  target="_blank"
                >
                  <img src={f3} alt="" />
                </a>
                <a
                  className="icon"
                  href="https://instagram.com"
                  target="_blank"
                >
                  <img src={f4} alt="" />
                </a>
              </div>
            </div>
            <div className="col">
              <h6>About Folksy</h6>
              <p onClick={() => routePage(history, "/about")}>
                The Folksy Story
              </p>
              <p onClick={() => routePage(history, "/contact")}>Contact us</p>
              <p onClick={() => routePage(history, "/privacy")}>
                Privacy Policy
              </p>
              <p onClick={() => routePage(history, "/terms")}>Terms of Use</p>
            </div>
            <div className="col">
              <h3>Discover gift ideas, new makers & special offers</h3>
              <div className="input-row">
                <input type="text" placeholder="Email Address" />{" "}
                <div className="btn">Sign Up</div>
              </div>
              <p>
                <b>Perks members get FREE shipping</b>
              </p>
              <p>
                Get unlimited FAST, FREE SHIPPING (and other good stuff) with a
                14-day free trial of Perks.
              </p>
              <p>contatc us:</p>
              <p>email:support@folksy.world</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default FooterBar;
